import { render } from "./GroupMembershipDuration.vue?vue&type=template&id=53c022c1&scoped=true"
import script from "./GroupMembershipDuration.vue?vue&type=script&lang=js"
export * from "./GroupMembershipDuration.vue?vue&type=script&lang=js"

import "./GroupMembershipDuration.vue?vue&type=style&index=0&id=53c022c1&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c022c1"]])

export default __exports__